import * as global from '@/scripts/core/global'

global.globalSetup()
